const page = (name, category = undefined, properties = {}) => {
  const analytics = window.analytics
  analytics.page(category, name, properties)
}

export default page
